<template>
  <div class="job-wrap">
    <div class="g-wrap">
      <!-- 搜索 -->
      <column-header2 :data="{ name: '问答服务' }"></column-header2>
      <div class="page-job">
        <div class="banner">
          <div class="search">
            <el-input v-model="queryParams.KeyWord" class="search-left" placeholder="搜索问题"></el-input>
            <div class="search-right" @click="getPageList('1')">搜索</div>
          </div>
          <div class="tags">
            <el-tag class="tag" :type="queryParams.tag == item.Id ? 'primary' : 'info'" v-for="item in tags" :key="item.Id" @click="select(item)">{{ item.Name }}</el-tag>
          </div>
        </div>

        <div class="g-wrap">
          <div v-if="questionList.length" class="g-content content">
            <question-card v-for="item in questionList" :data="item" :key="item.Id"></question-card>
            <el-pagination v-if="total > queryParams.pageSize" class="g-pagination" background layout="prev, pager, next" :current-page="queryParams.pageIndex" :page-size="queryParams.pageSize" :total="total" @current-change="handleIndexChange">
              ></el-pagination>
          </div>
          <div v-else class="nodata">
            <img @error="imgError" src="~assets/img/nodata.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnHeader from "_c/ColumnHeader2";
import { getHotTag, getPageList } from "api/question";
import QuestionCard from "./card";
export default {
  data() {
    return {
      total: 0,
      questionList: [],
      queryParams: {
        KeyWord: "",
        pageSize: 4,
        pageIndex: 1,
        tag: ""
      },
      tags: [],
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    QuestionCard
  },
  methods: {
    select(item) {
      if (this.queryParams.tag == item.Id) {
        this.queryParams.tag = "";
      } else {
        this.queryParams.tag = item.Id;
      }
      this.getPageList();
    },
    loadData() {
      getHotTag({ college: this.$store.getters.cid })
        .then(res => {
          this.tags = res.Result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取问题列表
    getPageList(index) {
      if(index && index == '1') {
        this.queryParams.pageIndex = 1;
      };
      this.queryParams.college = this.$store.getters.cid;
      getPageList(this.queryParams)
        .then(res => {
          this.questionList = res.Result.Data.map(item => {
            item.link = "question/detail/" + item.Id;
            return item;
          });
          this.total = res.Result.TotalCount;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleIndexChange(index) {
      this.queryParams.pageIndex = index;
      this.getPageList();
    },
    init() {
      this.loadData();
      this.getPageList();
    }
  }
};
</script>

<style lang="scss" scoped>
.job-wrap {
  background-color: #f6f6f9;
}
.page-job {
  padding-bottom: 40px;
  ::v-deep .comp-job {
    margin: 0 48px;
  }
  .content {
    padding-bottom: 48px;
    .g-pagination {
      margin-top: 24px;
    }
  }
}

.banner {
  // background: url(~assets/img/banner/招生信息banner.png) no-repeat top;
  background-size: 100% 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .search /deep/ {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 660px;
    height: 40px;
    background: #ffffff;
    border-radius: 4px;
    .el-input__inner {
      border-radius: 4px 0px 0px 4px;
    }
    .search-right {
      width: 103px;
      height: 40px;
      background: $primary-color;
      border-radius: 0px 4px 4px 0px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .tags {
    margin-top: 16px;
    .tag {
      cursor: pointer;
      margin: 0 4px;
    }
  }
}
.nodata {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  padding-bottom: 200px;
  img {
    width: 301px;
    height: 150px;
  }
}
</style>
